import React, { Fragment, memo } from 'react';
import { Link, useParams } from 'react-router-dom';
import AgencyActions from '@components/portal/details/top-bar-agency-actions';
import UserActions from '@components/portal/details/top-bar-user-actions';
import { colors } from '@constants/colors';
import { PERMISSION_GROUP_ADMIN } from '@constants/permission';
import { Icon, Tooltip } from '@mui';
import { allowedFor } from '@utils/permission-utils';
import './top-bar-view-actions.scss';

const TopBarViewActions = () => {
  const { dataType, id } = useParams();

  if (!allowedFor([PERMISSION_GROUP_ADMIN])) {
    return null;
  }

  return (
    <Fragment>
      {dataType !== 'batch' &&
        // A plain <a>, not IconButton - the Link is already the real, labeled interactive
        // element here, and MUI's ButtonBase always applies role="button"/tabIndex even when
        // rendered as a non-<button> tag, so IconButton would still nest a second interactive
        // widget inside the <a> (nested-interactive). The sizing/centering class goes
        // directly on the Link itself (not a further nested span) to match the sibling
        // "More actions" button's box exactly.
        <Tooltip title="Edit">
          <Link to={`/${dataType}/${id}/edit`} aria-label="Edit" styleName="edit-icon">
            <Icon color={colors.opacity.black0_8} aria-hidden="true">edit</Icon>
          </Link>
        </Tooltip>
      }
      {dataType === 'agency' && <AgencyActions />}
      {dataType === 'user' && <UserActions />}
    </Fragment>
  );
};

export default memo(TopBarViewActions);
